import { Canvas } from 'fabric'
import { useEffect, useRef, useState } from 'react'

import { ImageCanvasToolbar } from './image-canvas-toolbar'
import type { Detail } from '@/api/orders/orders-types'
import { Label } from '@/components/ui/label'
import { Switch } from '@/components/ui/switch'
import { getVariobendFile } from '@/utils/details'

interface ImageCanvasProps {
  data: Detail
}

export const ImageCanvas = ({ data }: ImageCanvasProps) => {
  const [viewOriginal, setViewOriginal] = useState(false)
  const canvasRef = useRef<HTMLCanvasElement>(null)
  const [canvas, setCanvas] = useState<Canvas | null>(null)

  useEffect(() => {
    if (canvasRef.current) {
      const fabricCanvas = new Canvas(canvasRef.current, {
        width: 900,
        height: 467,
        backgroundColor: 'white'
      })
      fabricCanvas.renderAll()
      setCanvas(fabricCanvas)

      return () => {
        fabricCanvas.dispose()
        setCanvas(null)
      }
    }
  }, [])

  const newestImage = getVariobendFile({ files: data.variobend_files })

  return (
    <div className='relative mt-10'>
      <div className='flex items-center space-x-2'>
        <Switch
          disabled={!newestImage}
          id='original'
          checked={viewOriginal}
          onCheckedChange={setViewOriginal}
        />
        <Label htmlFor='original'>View original image</Label>
      </div>

      <div
        key='fabric-canvas-container'
        className='relative'
      >
        <canvas
          className='w-full'
          id='canvas'
          ref={canvasRef}
          style={{ display: 'block' }}
        />
        {canvas && (
          <ImageCanvasToolbar
            data={data}
            canvas={canvas}
            viewOriginal={viewOriginal}
            className='absolute bottom-2 left-1/2 -translate-x-1/2'
          />
        )}
      </div>
    </div>
  )
}
